<script>
import RightLayout from '@/router/layouts/rightLayout'
import Editor from '@/components/quillEditor.vue'
import ShiftEventDetailWindowMask from '@/components/ShiftEventDetailWindowMask'
import ShiftDetailEventWindowMask from '@/components/ShiftDetailEventWindowMask'
import CalendarInput from '@/components/CalendarInput'
import dialog from '@/components/Dialog'
import {StringUtil} from '@/utils/StringUtil'
import { DateUtil } from '@/utils/date.js'
export default {
  components: {
    RightLayout,
    Editor,
    ShiftDetailEventWindowMask,
    CalendarInput,
    ShiftEventDetailWindowMask,
    'v-dialog': dialog
  },
  props: {
    title: {type: String, default: 'イベント作成'}
  },
  data () {
    return {
      isEmoji: false,
      shiftEventInfo: {},
      option: {
        imgs: null,
        file: null,
        chooseImageFlag: false
      },
      year: 2018,
      month: 10,
      day: 1,
      shiftEvent: {
        eventName: '',
        eventNote: '',
        eventDate: '',
        eventPhotoUrl: null
      },
      eventDate: '',
      shiftBasic: {},
      shiftPasspointObject: {
        shiftPasspoint: [],
        passpointNum: 0,
        showEvent: false,
        shiftReservationInfos: [],
        loopDateList: []
      },
      functionFlag: '',
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '',
        cancelButtonText: '',
        confirmButtonText: ''
      },
      // 限制图片大小,默认1MB
      uploadPictureMaxSize: 1,

      // 区域外対応
      shiftList: [{
        shiftBasic: {}
      }],
      shiftConnectList: [],
      connectList: [],
      connectGroupList: [],
      connectGroupHtml: '',
      // 削除予定便リスト
      removeShiftList: [],
    }
  },
  created () {
    if (sessionStorage.getItem('uploadPictureMaxSize')) {
      this.uploadPictureMaxSize = sessionStorage.getItem('uploadPictureMaxSize')
    }
    this.shiftEvent.eventName = ''
    this.functionFlag = this.$route.query.flag || ''
    if (sessionStorage.getItem('shiftEventInfo') !== null) {
      let shiftEventInfo = JSON.parse(sessionStorage.getItem('shiftEventInfo'))
      this.shiftEventInfo = shiftEventInfo
      let date = shiftEventInfo.eventInfo.eventDate
      this.shiftEvent = shiftEventInfo.eventInfo
      this.option.imgs = this.shiftEvent.eventPhotoUrl
      this.year = this.getYear(date)
      this.month = this.getMonth(date)
      this.day = this.getDay(date)
    } else {
      if (sessionStorage.getItem('shiftBasicModel') !== null) {
        this.shiftBasic = JSON.parse(sessionStorage.getItem('shiftBasicModel'))
        this.shiftList[0].shiftBasic = this.shiftBasic
        let date = this.shiftBasic.moveShiftTime
        this.year = this.getYear(date)
        this.month = this.getMonth(date)
        this.day = this.getDay(date)
      }
      if (sessionStorage.getItem('shiftPasspointList') !== null) {
        this.shiftPasspointObject.shiftPasspoint = JSON.parse(sessionStorage.getItem('shiftPasspointList'))
      }
      if (sessionStorage.getItem('shiftReservationInfoList') !== null) {
        this.shiftPasspointObject.shiftReservationInfos = JSON.parse(sessionStorage.getItem('shiftReservationInfoList'))
      }
      if (sessionStorage.getItem('loopDateList') !== null) {
        this.shiftPasspointObject.loopDateList = JSON.parse(sessionStorage.getItem('loopDateList'))
      } else {
        this.shiftPasspointObject.loopDateList = null
      }

      // 区域外対応
      if (sessionStorage.getItem('shiftList') != null) {
        this.shiftList = JSON.parse(sessionStorage.getItem('shiftList'))
      }
      if (sessionStorage.getItem('removeShiftList') != null) {
        this.removeShiftList = JSON.parse(sessionStorage.getItem('removeShiftList'))
      }
      if (sessionStorage.getItem('shiftConnectList') != null) {
        this.shiftConnectList = JSON.parse(sessionStorage.getItem('shiftConnectList'))
      }else{
        this.shiftConnectList = []
      }
      if (sessionStorage.getItem('connectGroupList') != null) {
        this.connectGroupList = JSON.parse(sessionStorage.getItem('connectGroupList'))
      }else{
        this.connectGroupList = []

      }
      if (sessionStorage.getItem('connectGroupHtml') != null) {
        this.connectGroupHtml = JSON.parse(sessionStorage.getItem('connectGroupHtml'))
      }else{
        this.connectGroupHtml = ''
      }

      this.shiftEventInfo = null
      console.log("event created")
      console.log(this.shiftList)
    }
  },
  methods: {
    // message dialog
    showMessage (text, yesNoFlag, yesText, noText) {
      this.dialogOption.text = text
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    // 检测图片是否合规
    checkImage (e) {
      let file = e.target.files[0]
      return new Promise((resolve, reject) => {
        let uploadPictureMaxSize = parseInt(sessionStorage.getItem('uploadPictureMaxSize'))
        if (file.size > uploadPictureMaxSize * 1024 * 1024) {
          this.showMessage(uploadPictureMaxSize + 'MBサイズ以下の画像を選択して下さい。')
          // 用来清空input的value，以免再次选择同样的图片时不检测。
          this.$refs.ctlImg.value = ''
          return reject
        }
        // JPEG或はJPG形式の画像だけが選択できます。 !/\.(jpg|jpeg|JPG)$/.test(e.target.value)
        if (!/\.(jpg|jpeg|JPEG|JPG|png|PNG|bmp|BMP)$/.test(e.target.value)) {
          this.showMessage('JPG、PNG或はBMP形式の画像だけが選択できます。')
          this.$refs.ctlImg.value = ''
          return reject
        }
        let reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          let img = new Image()
          img.src = data
          img.onload = () => {
            var width = img.width
            var height = img.height
            // ピクセル256×320以上の画像を選択して下さい。
            if (width < 256 || height < 320) {
              this.showMessage('ピクセル256×320以上の画像を選択して下さい。')
              this.$refs.ctlImg.value = ''
              return reject
            }
            let urllength = this.$refs.ctlImg.value.length
            let fileurl = this.$refs.ctlImg.value.substring(3, urllength)
            this.option.file = file
            this.$refs.ctlImg.value = ''
            return resolve({ data: data, fileurl: fileurl })
          }
        }
        reader.readAsArrayBuffer(file)
      })
    },
    // 加载图片
    uploadImg (e) {
      this.checkImage(e)
        .then(result => {
          if (result.data && result.fileurl) {
            // 允许跳转
            this.option.imgs = result.data
            this.shiftEvent.eventPhotoUrl = result.fileurl
            this.option.chooseImageFlag = true
          }
        })
        .catch(err => console.error(err))
    },
    chooseImage () {
      const event = new MouseEvent('click')
      this.$refs.ctlImg.dispatchEvent(event)
    },
    getEventNote (msg, isEmoji) {
      this.shiftEvent.eventNote = msg
      this.isEmoji = isEmoji
    },
    getEventDate (date) {
      this.shiftEvent.eventDate = date
    },
    cancel () {
      this.shiftList[0].shiftEvent = null
      if (this.functionFlag === '0') {
        this.shiftBasic.shiftType = '1'
        // sessionStorage.setItem('shiftBasicModel', JSON.stringify(this.shiftBasic))
        sessionStorage.setItem('shiftList', JSON.stringify(this.shiftList))
        sessionStorage.setItem('shiftConnectList', JSON.stringify(this.shiftConnectList))
        this.$router.push({path: '/ShiftLogin', query: { isCancel: true }})
      } else {
        if (this.functionFlag === '1') {
          sessionStorage.setItem('shiftList', JSON.stringify(this.shiftList))
          sessionStorage.setItem('shiftConnectList', JSON.stringify(this.shiftConnectList))
          this.$router.push({path: '/ShiftEditor', query: { editorIsCancel: true }})
        } else {
          this.$router.go(-1)
        }
      }
    },
    // 保存图片后登陆
    saveImage () {
      new Promise((resolve, reject) => {
        if (this.option.file !== null) {
          let file = this.option.file
          let formData = new FormData()
          formData.append('uploadFile', file)
          this.$axios.post('shift/saveEventImage', formData)
            .then((response) => {
              if (response.data.pictureUrl) {
                this.shiftEvent.eventPhotoUrl = response.data.pictureUrl
              }
              console.log(this.shiftEvent.eventPhotoUrl)
              resolve()
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.shiftEvent.eventPhotoUrl = null
          resolve()
        }
      }).then(() => {
        this.commitServer()
      })
    },
    commitServer () {
      console.log("commitServer")
      console.log(this.shiftList)
      this.shiftList[0].shiftEvent = this.shiftEvent
      this.shiftEvent.eventDate = this.dateyymmdd(this.shiftEvent.eventDate)

      // 編集画面の場合、便ごとに既存・新規の判定を入れる
      // 削除した既存便は削除フラグを立ててshiftListに戻してバックに投げる
      let activeShiftCount = this.shiftList.length
      if(this.functionFlag == '1'){
        for(let i=0; i < this.shiftList.length; i++){
          if(this.shiftList[i].functionFlag == '1'){
            this.shiftList[i].frontId = this.shiftList[i].shiftBasic.shiftId
          }
        }
        for(let i=0; i < this.removeShiftList.length; i++){
          this.removeShiftList[i].functionFlag = '4'
          this.shiftList.unshift(this.removeShiftList[i])
        }
        console.log("func1")
        console.log(this.shiftList)
      }
      this.$axios.post('shift/saveShiftInfoAndShiftConnect', {
          shiftCopeWithShiftConnectModelList: this.shiftList,
          shiftConnectModelList: activeShiftCount > 1 ? this.shiftConnectList : null,
          // shiftEvent: this.shiftEvent
          })
        .then(response => {
          // 消除 loopDateList
          sessionStorage.removeItem('loopDateList')
          // 从便编集过来的跳转
          if (this.$route.query.from === 'ShiftEditor') {
            // 将修改后便信息进行封装，并存放在session中，以供便详细画面显示
            // let shiftBasicModel = JSON.parse(sessionStorage.getItem('shiftBasicModel'))
            let shiftPasspoint = JSON.parse(sessionStorage.getItem('shiftPasspointList'))
            let shiftReservationInfos = JSON.parse(sessionStorage.getItem('shiftReservationInfoList'))
            let shiftInfo = {}
            shiftInfo.shiftId = this.shiftList[0].shiftBasic.shiftId
            shiftInfo.title = this.shiftList[0].shiftBasic.title
            shiftInfo.routeId = this.shiftList[0].shiftBasic.routeId
            shiftInfo.driveUid = this.shiftList[0].shiftBasic.driverUid
            shiftInfo.driverNameKana = this.shiftList[0].shiftBasic.driverKanaName
            shiftInfo.driverName = this.shiftList[0].shiftBasic.driverName
            shiftInfo.vehicleId = this.shiftList[0].shiftBasic.vehicleId
            shiftInfo.vehicleName = this.shiftList[0].shiftBasic.vehicleName
            shiftInfo.passengerNumber = this.shiftList[0].shiftBasic.passengerNumber
            shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftList[0].shiftBasic.moveShiftTime)
            shiftInfo.shiftFlag = Number(this.shiftList[0].shiftBasic.shiftFlag)
            if (this.shiftList[0].shiftBasic.shiftFlag === '0') {
              shiftInfo.startEstimateTimeSlot = this.shiftList[0].shiftBasic.startEstimateTimeSlot
            } else {
              shiftInfo.arriveEstimateTimeSlot = this.shiftList[0].shiftBasic.arriveEstimateTimeSlot
            }
            shiftInfo.shiftCost = this.shiftList[0].shiftBasic.shiftCost
            shiftInfo.reserveNumber = this.shiftList[0].shiftBasic.reserveNumber
            shiftInfo.eventId = this.shiftList[0].shiftBasic.eventId
            shiftInfo.shiftType = this.shiftList[0].shiftBasic.shiftType
            shiftInfo.areaId = this.shiftList[0].shiftBasic.areaId
            shiftInfo.areaName = this.shiftList[0].shiftBasic.areaName
            shiftInfo.shiftMovementStatus = this.shiftList[0].shiftBasic.shiftMovementStatus
            shiftInfo.businessStatus = this.shiftList[0].shiftBasic.businessStatus
            shiftInfo.shiftPasspoints = shiftPasspoint
            shiftInfo.shiftReservationInfos = shiftReservationInfos
            // event作成成功后添加eventId
            shiftInfo.eventId = response.data.eventId
            // 将更改更新到Session中
            sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: shiftInfo, shiftPasspoints: shiftPasspoint}))
            sessionStorage.setItem('routeName', JSON.stringify(this.shiftList[0].shiftBasic.routeName))
            this.$router.push({path: '/ShiftWithEventDetail', query: {from: 'EventGenerate', shiftId: this.shiftList[0].shiftBasic.shiftId}})
          } else {
            this.$router.push({path: '/MovementShift'})
          }
        })
        .catch(error => {
          console.log("APIエラー")
          console.log(error)
          if (error.data.error === 'WBE2001') {
            this.showMessage(error.data.error_description)
          }else{
            this.showMessage('予期せぬエラーが発生しました。')
          }
        })
    },
    submit (e) {
      // 去前后空字符串
      this.shiftEvent = StringUtil.trim(this.shiftEvent)
      this.shiftList[0].shiftEvent = this.shiftEvent
      this.$validator.validateAll()
        .then(result => {
          if (!result) {
            e.stopPropagation()
          }
        })
      if (this.isEmoji) {
        e.stopPropagation()
      }
      this.shiftPasspointObject.showEvent = true
      // 获取a标签Dom
      let model = document.getElementById('modal-shift-event-detail')
      if (this.shiftEventInfo === null) {
        model = document.getElementById('modal-shift-detail-event')
      }
      // 每次进来地址为空不跳转
      model.href = 'javascript:void(0)'
      this.$validator.validateAll().then(result => {
        if (result && this.shiftEventInfo !== null) {
          model.href = '#modal-container-shift-event-detail'
        } else if (result) {
          model.href = '#modal-container-shift-detail-event'
          this.$refs.shiftInfoDialog
            .confirm()
            .then(() => {
              // 将数据传到后台
              // this.commitServer()
              this.saveImage()
            })
        }
      })
    },
    getYear (date) {
      if (date !== null && date !== '') {
        let year = date.substr(0, 4)
        return parseInt(year)
      }
    },
    getMonth (date) {
      if (date !== null && date !== '') {
        if (date.charAt(4) === '0') {
          return parseInt(date.charAt(5))
        } else {
          return parseInt(date.substr(4, 2))
        }
      }
    },
    getDay (date) {
      if (date !== null && date !== '') {
        if (date.charAt(6) === '0') {
          return parseInt(date.charAt(7))
        } else {
          return parseInt(date.substr(6, 2))
        }
      }
    },
    dateyymmdd (val) {
      let yymmdd = val.split('(')[0]
      let year = yymmdd.split('年')[0]
      let month = yymmdd.split('月')[0].split('年')[1]
      let day = yymmdd.split('月')[1].split('日')[0]
      if (month.length !== 2) {
        month = '0' + month
      }
      if (day.length !== 2) {
        day = '0' + day
      }
      return year + month + day
    }
  }
}
</script>
<template>
  <RightLayout>
    <div class="col-md-12 column header">
      <div class="col-md-4 column"></div>
      <div class="col-md-4 column F3-M-27">
          <span v-if="shiftEventInfo === null">{{title}}</span>
          <span v-else>イベント編集</span>
      </div>
      <div class="col-md-4 column"></div>
    </div>
    <div class="col-md-14 column height25 divMarginTop_20px">
      <div class="col-md-1 column"></div>
            <div class="col-md-2 column paddingLeftZero height100">
              <div class="img-bg bgc10">
                <img v-show="option.imgs!=null" :src="option.imgs" class="img-style">
                <div v-show="option.imgs==null" class="noimg-style bgc10 F2-M-18">No Image</div>
              </div>
            </div>
            <div class="col-md-4 column height100">
                <div class="row clearfix">
                    <div class="col-md-12 column">
                      <input
                        ref="ctlImg"
                        class="fileInput"
                        name="uploadPicture"
                        type="file"
                        accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
                        @change="uploadImg($event)">
                        <button
                          id="imgSelect"
                          style="float:left;margin-top:20%;"
                          type="button"
                          class="T7-radius F2-R-19"
                          @click="chooseImage">イベント写真を選択</button>
                    </div>
                </div>
                <div class="row clearfix">
                    <div class="col-md-12 column textAlignLeft" style="margin-top: 30px;">
                        ※最大アップロードファイルサイズ{{uploadPictureMaxSize}}MB
                    </div>
                </div>
             </div>
    </div>
    <div class="col-md-14 column divMarginTop">
      <div class="col-md-1 column"></div>
      <div class="col-md-1 column" >
        <span class="F3-R-14">※必須項目</span>
      </div>
    </div>
    <div class="col-md-14 column">
       <div class="col-md-1 column"></div>
      <div class="col-md-1 column T7-tip bgc8 F3-R-15">
        <span class="star F3-R-15">※</span>イベント名
      </div>
       <div class="col-md-9 column">
          <input
          type="text"
          class="F3-R-20"
          name="shiftName"
          maxlength="500"
          v-validate="'required|paintWordNo'"
          v-model="shiftEvent.eventName">
       </div>
    </div>
    <div class="col-md-14 column divMarginTop_5px">
       <div class="col-md-1 column"></div>
      <div class="col-md-1 column" style="width:150px">
      </div>
       <div class="col-md-9 column textAlignLeft">
          <span v-show="errors.has('shiftName')" class="errorMessage">{{errors.first('shiftName')}}</span>
       </div>
    </div>
    <div class="col-md-14 column divMarginTop_5px">
      <div class="col-md-1 column"></div>
      <div class="col-md-1 column T7-tip bgc8 F3-R-15">
        <span class="star F3-R-15" >※</span>開催日
        </div>
      <div class="col-md-9 column ">
        <calendar-input @getValue="getEventDate"
        :need-weeks="true"
        :input-style="'font-size: 16px;padding-left:12px'"
        :selectY="this.year"
        :selectM="this.month"
        :selectD="this.day">
        </calendar-input>
      </div>
    </div>
    <div class="col-md-14 column height30 divMarginTop_5px">
      <div class="col-md-1 column"></div>
        <div class="col-md-1 column height100 " style="padding:0px">
          <div class="width100 height20"></div>
            <div class="T7-key bgc8 F3-R-15">
              開催概要
            </div>
        </div>
        <div class="col-md-9 column" style="height:100%">
          <Editor @transEvent="getEventNote"></Editor>
        </div>
      <div class= "col-md-1 column"></div>
    </div>
    <div class="col-md-14 column divMarginTop_5px">
       <div class="col-md-1 column"></div>
      <div class="col-md-1 column" style="width:150px">
      </div>
       <div class="col-md-9 column textAlignLeft">
          <span v-show="isEmoji" class="errorMessage">不正な入力です。</span>
       </div>
    </div>
  <div class="col-md-12 column divMarginTop" style="margin-top: 10px">
    <div class="col-md-6 column">
      <div v-if="shiftEventInfo === null">
        <a id="modal-shift-detail-event"  @click="submit()"  data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
          <Button class="window-button" style="width: 50%; float:right" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">登録</Button>
        </a>
      </div>
      <div v-else>
        <a id="modal-shift-event-detail"  @click="submit()"   data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
        <Button class="window-button" style="width: 50%; float:right" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">保存</Button>
      </a>
      </div>
    </div>
    <div class="col-md-6 column">
      <Button class="window-button" style="width: 50%; float:left" @click="cancel">キャンセル</Button>
    </div>
    <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
    <shift-detail-event-window-mask
      :eventInfoModel="shiftEvent"
      :option="option"
      :shiftBasicModel="shiftBasic"
      :functionFlag="functionFlag"
      :shiftPasspointObject="shiftPasspointObject"
      :shiftList ="shiftList"
      :shiftConnectList ="shiftConnectList"
      :connectGroupList ="connectGroupList"
      :connectGroupHtml ="connectGroupHtml"
      ref="shiftInfoDialog">
    </shift-detail-event-window-mask>
     <shift-event-detail-window-mask
    :eventInfoModel="shiftEvent"
    :option="option">
    </shift-event-detail-window-mask>
  </div>
  <!-- <div>
    <hr style=" background-color:black; width:200px; height:1px; border:none "/>
  </div> -->
  </RightLayout>
</template>
<style scoped>
@import "../../assets/css/C00.css";
.name-strong{
  font-size: 30px;
}
.star{
  float: left;
}
input{
width: 100%;
height: 41px;
padding-left: 10px;
}
.T7-tip {
  /* width: 150px; */
  background: #cecece;
  height: 41px;
  line-height: 41px;
  font-size: 15px;
  color: black;
}
.T7-key{
  width: 100%;
  height: 80%;
  background: #cecece;
  color: black;
  display:flex;
  flex-direction:column;
  justify-content:center;
}
.T7-radius {
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
  border-radius: 30px;
  color: #ffffff;
  font-size: 17px;
  padding: 10px;
  border: none
}
.T7-shortbtn {
  width: 50%;
  float: left;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
}
.fileInput {
  position: absolute;
  clip: rect(0 0 0 0);
}
.img-bg{
   width:100%;
   height:100%;
   display:table;
   position:absolute;
  }
.img-style{
  height:100%;
  width:100%;
  }
.textAlignLeft{
  text-align: left;
}
.textAlignRight{
  text-align: right;
}
.paddingLeftZero{
  padding-left: 0px;
}
.paddingRightZero{
  padding-right: 0px;
}
.divMarginTop{
  margin-top: 10px;
}
.divMarginTop_20px{
  margin-top: 20px;
}
.divMarginTop_5px{
  margin-top: 5px;
}
.height100{
  height: 100%;
}
.height25{
  height: 25%;
}
.height30{
  height: 30%;
}
.height10{
  height: 10%;
}
.height20{
  height: 20%
}
.width100{
  width: 100%
}
.calendar-input-container{
  /* 设置日历input的宽度 */
  display: block;
  width: 50%;
}
.errorMessage {
  color: red;
}
.noimg-style{
  color: #fff;
  height:100%;
  width:100%;
  font-size: 20px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  /* display: flex;
  align-items:center; */
}
.header {
  margin-top: 30px;
}
.footer{
  margin-top: 40px;
  position: fixed;
  bottom: 40px;
  width: 100%;
  padding-right: 300px;
}
</style>



// WEBPACK FOOTER //
// src/router/views/Event_Generate.vue